import { render } from "./LessonPlanningResources.vue?vue&type=template&id=32c1dece"
import script from "./LessonPlanningResources.vue?vue&type=script&lang=js"
export * from "./LessonPlanningResources.vue?vue&type=script&lang=js"

import "./LessonPlanningResources.vue?vue&type=style&index=0&id=32c1dece&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__